import * as React from 'react'
// libs
import { FieldArray, InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/index'
// components
import Rules from './components/Rules'
import Filters from './components/Filters'
import { Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
// views
import { ButtonsWrapper, Form } from './views'
// types
import { IOption } from 'components/FormElements/Select'

export type SyncRulesFormData = {
  mappings: {
    id?: string
    conditions: {
      value: {
        value: string
      }
      action: IOption
      fieldName: IOption
    }[]
    transactions: {
      id?: string
      fieldName: IOption
      fieldValue?: IOption
      transactionType: string
    }[]
  }[]
  filterMappings: {
    id?: string
    conditions: {
      value: {
        value: string
      }
      action: IOption
      fieldName: IOption
    }[]
  }[]
}

interface Props {
  onCancel: () => void
}

const SyncRulesForm: React.FC<Props & InjectedFormProps<SyncRulesFormData, Props>> = ({
  onCancel,
  submitting,
  handleSubmit
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Scrollbar>
        <FieldArray<any> name='mappings' component={Rules} />
        <FieldArray<any> name='filterMappings' component={Filters} />
      </Scrollbar>
      <ButtonsWrapper>
        <Button disabled={submitting} shadowLess type='submit' layout={BUTTON_LAYOUTS.PURPLE}>
          Save
        </Button>
        <Button
          shadowLess
          type='button'
          onClick={onCancel}
          disabled={submitting}
          layout={BUTTON_LAYOUTS.PURPLE_INVERTED}>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Form>
  )
}

export default reduxForm<SyncRulesFormData, Props>({
  form: Forms.SYNC_RULES_FORM,
  enableReinitialize: true,
  destroyOnUnmount: true
})(SyncRulesForm)
